/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="my-returns with-loader-absolute">
    <div class="account-content">
      <div class="account-content__body">
        <!-- seleziona ordine -->
        <div class="rma-step1" v-show="!editInfo && !guest">
          <b-form-group id="groupSelectOrder" >
            <base-select
              name="orderOpt"
              v-model="orderSelected"
              :options="orderOptions"
              :reduce="order => order.value"
              :placeholder="'*' + $t('SelectOrder')"
            />
          </b-form-group>
          <button class="btn btn-primary" type="button" :disabled="!orderSelected" @click="openOrder">{{$t('Proceed')}}</button>
        </div>
        <div class="rma-step2" v-if="editInfo">
          <div class="row first-row">
            <div class="col">
              <div class="wrapp-info-col">
                <h3 class="title">{{$t('rma.request_information')}}: </h3>
                <div class="wrapp-info-text">
                  <div class="wrapp-info">
                    <p>{{$t('rma.customer_name')}}: </p> <p>{{rmaDetailTemplate.customer_name}}</p>
                  </div>
                  <div class="wrapp-info">
                    <p>{{$t('rma.email_address')}}: </p> <p>{{rmaDetailTemplate.customer_email}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="wrapp-info-col shipping d-flex flex-column h-100">
                <h3 class="title">{{$t('order.shipping-address')}}</h3>
                <div class="wrapp-info-text mt-auto">
                  <div class="wrapp-info">
                    <p>
                      <span> {{rmaDetailTemplate.shipping_info.lastname}} {{rmaDetailTemplate.shipping_info.firstname}}<br></span>
                      <span> {{rmaDetailTemplate.shipping_info.street}} </span>
                      <span> {{rmaDetailTemplate.shipping_info.city}}, {{rmaDetailTemplate.shipping_info.region}}, {{rmaDetailTemplate.shipping_info.postcode}} </span>
                      <span> {{rmaDetailTemplate.shipping_info.country_id}} </span>
                      <span> {{rmaDetailTemplate.shipping_info.telephone}} </span>
                    </p>
                    <!-- use same css logic of above .wrapp-info-col -->
                    <p></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="wrapp-expander" @click.prevent="toggleInfoPanel(true)" style="display: none;">
              <svg class="o-icon fill-black"><use xlink:href="#arrows-expand"></use></svg>
            </div>
          </div>
          <div class="second-row">
            <h3 class="title">{{$t('rma.productsMultiSelect')}}</h3>
            <div class="bcm-table">
              <NewRmaProducts :items="rmaDetailTemplate.items" :dictionary="rmaDetailTemplate.dictionary" ref="productList" @productOpened="productOpened"/>
            </div>
            <!-- add message -->
            <add-message v-show="!guest" :reply.sync="replyMessage" :files.sync="filesMessage" :rmaId="rmaId" ref="addMessageRma" :hideSubmit="true" class="mt-3" :creationForm="true" />
          </div>
        </div>
      </div>
      <div class="account-content__footer">
        <div class="sticky-buttom d-flex align-items-center">
          <button class="cta btn btn-icon-text-out" @click="closeOrder">
            <svg class="o-icon stroke-black"><use xlink:href="#circle-close"></use></svg>
            <span class="text">{{ $t('Cancel') }}</span>
          </button>
          <button class="cta btn btn-primary btn-primary-medium btn-primary-with-icon btn-rounded btn-primary-black" @click="handleSubmit">
            <span class="text">{{ $t('Save') }}</span>
            <svg class="o-icon fill-white"><use xlink:href="#return-order"></use></svg>
          </button>
        </div>
      </div>
    </div>
    <absolute-loader :showLoader="rmaCall" mode="fixed"></absolute-loader>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { toast } from 'theme/modules/notifications'
import filter from 'lodash/filter'
import { writeOperationLog } from 'theme/helpers'
import Rma from '@/services/Rma'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import NewRmaProducts from 'theme/components/MyAccount/Rma/NewRmaProducts'
import AddMessage from 'theme/components/MyAccount/Rma/AddMessage'
import BaseSelect from 'theme/components/Form/BaseSelect'
import Logger from '@/services/Logger'

export default {
  name: 'MyReturnsNew',
  inject: ['$validator'],
  data () {
    return {
      guest: false,
      rmaCall: false,
      closeInfoPanel: false,
      rmaDetail: {},
      rmaDetailTemplate: {},
      orderSelected: '',
      orderOptions: [],
      editInfo: false,
      replyMessage: '',
      filesMessage: [],
      rmaId: '',
      firstInteraction: true,
      fields: [
        {
          key: 'name',
          label: this.$t('product-name')
        },
        {
          key: 'empty-col',
          label: ''
        },
        {
          key: 'color',
          label: this.$t('color')
        },
        {
          key: 'size',
          label: this.$t('size')
        },
        {
          key: 'price',
          label: this.$t('price')
        },
        {
          key: 'qty',
          label: this.$t('Quantity')
        },
        {
          key: 'sub-total',
          label: this.$t('subtotal')
        }
      ]
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.current
    })
  },
  methods: {
    init () {
      const _this = this
      this.isGuest()
      if (_this.guest) {
        this.checkGuestOrder().then(() => {
          this.getTemplateByOrder(_this.$route.params.id, _this.$route.params.email)
        })
      } else {
        this.getOrderAvailable()
      }
    },
    getOrderAvailable () {
      const _this = this
      _this.rmaCall = true
      Rma.getOrderAvailable({
        token: this.$store.state.user.token,
        storeViewCode: this.$store.state.ui.storeViewCode
      })
        .then(data => {
          _this.orderOptions = data.orderOptions
        })
        .finally(() => {
          _this.rmaCall = false
        })
    },
    isGuest () {
      const _this = this
      const id = this.$route.params.id
      const email = this.$route.params.email
      if (id && email) {
        _this.guest = true
      }
    },
    checkGuestOrder () {
      return Rma.checkGuestOrder({
        token: this.$store.state.user.token,
        storeViewCode: this.$store.state.ui.storeViewCode,
        orderId: this.$route.params.id,
        email: this.$route.params.email
      }).then((res) => {
        if (res.hasOwnProperty('errors')) {
          toast.error(res.errors[0].message)
          self.$router.push({ name: 'createGuestReturn' })
        }
      })
    },
    getTemplateByOrder (orderId, email) {
      const _this = this
      _this.rmaCall = true
      return Rma.getOrderTemplate({
        token: this.$store.state.user.token,
        storeViewCode: this.$store.state.ui.storeViewCode,
        orderId,
        email
      })
        .then(rmaDetailTemplate => {
          if (_this.guest) {
            if (rmaDetailTemplate.hasOwnProperty('errors')) {
              toast.error(rmaDetailTemplate.errors[0].message)
            } else
            if (rmaDetailTemplate.order_id) {
              _this.orderSelected = rmaDetailTemplate.orderId
              _this.editInfo = true
            }
          }
          _this.rmaDetailTemplate = rmaDetailTemplate
        })
        .finally(() => {
          _this.rmaCall = false
        })
    },
    closeOrder () {
      this.orderSelected = ''
      this.editInfo = false
      this.$router.push({ name: 'ReturnCancelled', params: { id: this.$route.params.id, email: this.$route.params.email } })
    },
    openOrder () {
      const _this = this
      this.firstInteraction = false
      if (this.orderSelected) {
        this.getTemplateByOrder(this.orderSelected).then(() => {
          _this.editInfo = true
        })
      } else {
        _this.editInfo = false
      }
    },
    validRMA () {
      // check same resolution_id
      let _resolutionId = null
      let valid = true
      const _items = filter(this.$refs['productList'].items, { _showDetails: true })
      for (let i in _items) {
        if (_resolutionId === null) {
          _resolutionId = _items[i].dictionarySelected.resolution_id
        } else {
          if (_resolutionId !== _items[i].dictionarySelected.resolution_id) {
            toast.error(this.$t('rma.resolutionNeedSameValue'))
            return false
          }
        }
      }
      return valid
    },
    handleSubmit () {
      const _this = this
      this.validateRequest(this.$refs['productList'].$children).then(isValid => {
        if (isValid.includes(true)) {
          if (!this.validRMA()) {
            return true
          }
          // save RMA
          _this.rmaCall = true
          let inputRma = Rma.buildInputRma({
            items: filter(_this.$refs['productList'].items, { showDetails: true }),
            order: _this.rmaDetailTemplate,
            storeId: _this.$store.getters['storeConfig/storeviewID'],
            reply: _this.replyMessage,
            email: this.$route.params.email || ''
          })
          Rma.createRMA({
            token: _this.$store.state.user.token,
            storeViewCode: _this.$store.state.ui.storeViewCode,
            inputRma: inputRma,
            files: _this.filesMessage
          }).then(res => {
            _this.rmaId = res.guest_id
            writeOperationLog('rma-creation', _this.$store.getters['userAdmin/getCurrentAgentID'])
            return _this.$refs.addMessageRma.sendMessage(_this.rmaId)
              .then(successAddMessage => {
                if (successAddMessage) {
                  _this.$router.push({ name: 'ReturnSuccess', params: { id: _this.$route.params.id, email: _this.$route.params.email } })
                } else {
                  toast.error(_this.$t('rma.attachmentError'))
                }
              })
          })
            .catch(err => {
              let message = err && err.body ? err.body.result : 'GenericError'
              Logger.error(err)
              toast.error(_this.$t(message))
            })
            .finally(() => {
              _this.rmaCall = false
            })
        }
      })
    },
    validateRequest (elements) {
      const promiseArr = []
      elements.forEach(element => {
        promiseArr.push(
          element.isValid().then(isValid => {
            if (!isValid) {
              // open panel if close
              element.toggleDetail({ alwaysTrue: true })
            }
            return isValid
          })
        )
      })
      return Promise.all(promiseArr).then((res) => {
        return res
      })
    },
    productOpened (boolVal) {
      this.toggleInfoPanel(boolVal)
    },
    toggleInfoPanel (toggle) {
      $('.wrapp-expander').fadeToggle(toggle)
      $('.wrapp-info-text').slideToggle(toggle)
    }
  },
  beforeMount () {
    if (process.client) {
      const pageTitle = `${this.$t('Order')}: #${this.$route.params.id}`
      return this.$store.commit('ui/setHeaderPageTitle', pageTitle)
    }
  },
  mounted () {
    this.init()
  },
  components: {
    AbsoluteLoader,
    NewRmaProducts,
    AddMessage,
    BaseSelect
  }
}
</script>
